module.exports = "https://99designs-start-assets.imgix.net/js/a5684ccedfb52daa307fb767ba13aed4.png";